import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { Link, Redirect } from "react-router-dom";
import { BackButton } from "ui/button/back";
import { NavLoader } from "ui/loader";
import { Notification } from "ui/notification";
import { ParameterForm } from "ui/parameter-form";
import { getErrorMessage } from "util/response";
import { Box } from "view/layout/box";
import { Page } from "view/layout/page";

class ConfigureDevicePage extends React.PureComponent {
  static get propTypes() {
    return {
      device: PropTypes.object,
      readonly: PropTypes.bool.isRequired,
      storesLoaded: PropTypes.bool.isRequired,
      updateParams: PropTypes.func.isRequired,
    };
  }

  constructor(props) {
    super(props);

    this.state = {
      errorMessage: "",
      successMessage: "",
      submitted: false,
    };

    this._submit = this._submit.bind(this);
    this._updateParams = this._updateParams.bind(this);
  }

  _submit() {
    this.setState({ submitted: true }, this._updateParams);
  }

  _updateParams() {
    const { device, updateParams } = this.props;
    const serviceArgs = {
      id: device.id,
      params: this.form.getParams(),
    };

    return updateParams(serviceArgs)
      .then(() => {
        this.setState({
          errorMessage: "",
          successMessage: "Device parameters updated successfully.",
        });
      })
      .catch((e) => {
        this.setState({
          errorMessage: getErrorMessage(e),
          successMessage: "",
        });
      })
      .finally(() => {
        this.setState({
          submitted: false,
        });
      });
  }

  _renderView() {
    const { device, storesLoaded, readonly } = this.props;
    const { errorMessage, submitted, successMessage } = this.state;

    if (!storesLoaded) {
      return <NavLoader.Proxy />;
    }

    if (!device) {
      return <Redirect to="/404" />;
    }

    const params = device.user_params
      .filter((param) => !param.app_id)
      .reduce((acc, param) => {
        acc[param.name] = param.value;

        return acc;
      }, {});

    return (
      <Row>
        <Col xs={12}>
          <Notification
            error={errorMessage}
            success={successMessage}
            successChildren={
              <Link to={`/devices/${device.device_id}/overview`}>
                View Device
              </Link>
            }
          />
          <Row>
            <Col xs={12}>
              <ParameterForm
                params={params}
                readonly={readonly}
                ref={(f) => {
                  this.form = f;
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              <BackButton />
              <Button
                variant="primary"
                onClick={this._submit}
                className={classNames({ hide: readonly })}
                disabled={submitted}
              >
                Update
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
    );
  }

  render() {
    const { device } = this.props;
    const view = this._renderView();
    const deviceName = device ? device.name : "Device";

    return (
      <Page title={`Configure ${deviceName}`}>
        <Box noHeader={true}>{view}</Box>
      </Page>
    );
  }
}

export { ConfigureDevicePage };
